export function liveRequestsAllowed({ enabled, paused, hidden, unmounted, mode }) {
    return mode === "live" && Boolean(enabled) && !paused && !hidden && !unmounted;
}

export function stopLiveRuntime(runtime) {
    if (runtime.timer != null) {
        clearTimeout(runtime.timer);
        runtime.timer = null;
    }
    runtime.generation += 1;
    if (runtime.controller) {
        runtime.controller.abort();
        runtime.controller = null;
    }
    return runtime;
}

export function responseIsCurrent(runtime, generation, aborted) {
    return !runtime.unmounted && runtime.generation === generation && !aborted;
}
